<template>
  <div>
    <h1>Activar verificación provisional</h1>
    <b-alert
      :show="dismissCountDown"
      dismissible
      :variant="mensaje.color"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
    >
      {{mensaje.texto}}
    </b-alert>
    <div class="card">
      <div class="card-body">
        <h5 class="mb-4"></h5>
        <a-form :form="form" @submit.prevent="handleSubmit" layout="vertical">
          <div class="row">
            <div class="col-md-6">
              <a-form-item label="Responsable">
                <a-input
                disabled
                v-model="$v.createVerification.authorizeBy.$model"
                />
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Número de Concesión">
                <a-input
                  disabled
                  placeholder="Número de Concesión"
                  v-model="$v.createVerification.numConcesion.$model"
                />
                <small class="text-danger" v-if="!$v.createVerification.numConcesion.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="RFC">
                <a-input
                  disabled
                  placeholder="RFC"
                  v-model="$v.createVerification.rfc.$model"
                />
                 <small class="text-danger" v-if="!$v.createVerification.rfc.required">Campo requerido. No debe estar vacío.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Periodo">
                <a-input
                placeholder="Ej, 2022-4"
                v-model="$v.createVerification.period.$model"
                />
                 <small class="text-danger" v-if="!$v.createVerification.period.required">Campo requerido. No debe estar vacío.</small>
                 <small class="text-danger" v-if="!$v.createVerification.period.period">Solo se permite fecha por números.</small>
              </a-form-item>
            </div>
            <div class="col-md-6">
              <a-form-item label="Motivo">
                <a-input
                v-model="$v.createVerification.reason.$model"
                />
                 <small class="text-danger" v-if="!$v.createVerification.reason.required">Campo requerido. No debe estar vacío.</small>
                 <small class="text-danger" v-if="!$v.createVerification.reason.maxLength">Ingresa un comentario menor o igual a docientos caracteres</small>
              </a-form-item>
            </div>
            <div class="col-12">
              <a-form-item>
                <button
                :disabled="!(validateRegisteredConcesion($v.createVerification.$model) && !$v.$invalid)"
                  type="submit"
                  class="btn btn-light px-5"
                >
                  Guardar
                </button>
              </a-form-item>
            </div>
          </div>
        </a-form>
      </div>
    </div>
  </div>
</template>

<script>
import gql from 'graphql-tag'
import { required, helpers, maxLength } from 'vuelidate/lib/validators'
// import { encrypt } from '@/config/headers'
import headers from '@/config/headers.js'
const period = helpers.regex('period', /^([12]\d{3}-([1-9]|1[0-2]))$/)
export default {
  data() {
    return {
      disabledButton: false,
      form: this.$form.createForm(this),
      createVerification: {
        reason: '',
        authorizeBy: this.$store.state.user.email,
        rfc: this.$route.params.concesionario.rfc,
        numConcesion: this.$route.params.concesionNumber,
        period: '',
      },
      mensaje: { color: '', texto: '' },
      dismissSecs: 5,
      dismissCountDown: 0,
      registeredConcesiones: {},
      // getAllConceciones: []
    }
  },
  apollo: {
  },
  methods: {
    async handleSubmit() {
      if (this.$v.$invalid) {
        this.mensaje.texto = 'Campos inválidos, comprueba tus datos'
        this.mensaje.color = 'danger'
        this.showAlert()
        return
      }
      this.disabledButton = true
      await this.$apollo.mutate({
        mutation: gql`mutation createVerification($reason: String, $authorizeBy: String, $rfc: String, $numConcesion: String, $period: String){
         createVerification(tempVerificationInput: {
          reason: $reason
          authorizeBy: $authorizeBy
          rfc: $rfc
          numConcesion: $numConcesion
          period: $period
        }){
          success
        }
        }`,
        context: headers(),
        variables: {
          // tempVerificationInput: this.createVerification,
          reason: this.createVerification.reason,
          authorizeBy: this.createVerification.authorizeBy,
          rfc: this.createVerification.rfc,
          numConcesion: this.createVerification.numConcesion,
          period: this.createVerification.period,
        },
      })
        .then(res => {
          console.log(this.createVerification, 'creado')
          this.$router.push('/concessions/getConcessions')
        })
        .catch(error => {
          console.log(this.createVerification, 'No salio')
          console.log(error)
          this.disabledButton = false
          this.mensaje.texto = 'Ocurrió un error, intentalo de nuevo'
          this.mensaje.color = 'warning'
          this.showAlert()
        })
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    showAlert() {
      this.dismissCountDown = this.dismissSecs
    },
    validateRegisteredConcesion(concesionNumber) {
      if (this.createVerification[concesionNumber]) {
        return false
      } else {
        return true
      }
    },
  },
  created() {
    console.log(this.$route.params, 'params')
  },
  validations: {
    createVerification: {
      reason: { required, maxLength: maxLength(200) },
      authorizeBy: { required },
      rfc: { required },
      numConcesion: { required },
      period: { required, period },
    },
  },
}
</script>

<style>

</style>
